export default "__VITE_ASSET__JtAImQsi__"